<template>
  <!-- 表单字段，可做字段校验，但不支持复杂规则，只支持长度和必填 -->
  <div class="form-item" :class="(showBlock? 'show-block': '') + (colSpan !== 1? 'col-span-'+colSpan: '')" :style="{alignItems: alignItems}">
    <div class="form-label" :class="required? 'required': ''">
      <slot name="title">{{label}}</slot>
    </div>
    <div class="form-value">
      <slot/>
      <div class="form-error" v-if="showError">{{errorMessage}}</div>
      <div class="form-desc" v-else-if="descMessage">{{descMessage}}</div>
    </div>
    <div class="form-append">
      <div class="append">
        <slot name="append" />
      </div>

    </div>
  </div>
</template>

<script>
// 如果要进行规则校验，required必须为true, 必须指定name
import YqIcon from "@/components/YqIcon.vue";

/**
 * 可进行校验的方式有：
 * 1 maxLength,用于String 最大长度, 当maxLength=0时无效
 * 2 minLength,用于String 最小长度，当minLength=0时无效
 * 3 max,用于Number 最大值，当max=0时无效
 * 4 min,用于Number 最小值，当min=0时无效
 * 5 pattern,用于String 正则表达式
 * 6 checkFunction,自定义的验证方法，参数为data,返回true表示验证通过，false表示验证失败
 */
export default {
  props: {
    colSpan: {default: 1}, // 列的跨度
    label: {default: ""},
    // 是否必填
    required: {default: false},
    // 是否显示为块状元素，是否单独显示一行
    showBlock: {default: false},
    // 必填选项未填的错误提示语
    errorMessage: {default: ""},
    // 表单字段名, 数据校验时必须要填写，否则失效
    name: {default: ""},

    maxLength: {default: 0},// 最大长度
    minLength: {default: 0},// 最小长度
    max: {default: 0},// 最大值
    min: {default: 0},// 最小值
    pattern: {default: ""}, // 正则表达式
    checkFunction: {default: null}, // 自定义数据验证方法
    descMessage: {default: ""}, // 对于填充内容的描述信息
    alignItems: {default: "center"},
  },
  name: "FI",
  components: {
    YqIcon
  },
  data() {
    return {
      showError: false, // 显示异常消息
    };
  },
  created() {
    if (this.$parent && this.$parent.addFormItem) {
      this.$parent.addFormItem(this);
    }
  },
  beforeUnmount() {
    if (this.$parent && this.$parent.removeFormItem) {
      this.$parent.removeFormItem(this);
    }
  },
  methods: {
    showErrorMessage() {
      this.showError = true;
    },
    hideErrorMessage() {
      this.showError = false;
    },
  }
};
</script>

<style lang="scss" scoped>
.form-item{
  display: inline-flex;
  position: relative;
  padding-bottom: 20px;
  font-size: 14px;
  .form-label{
    width: var(--label-width);
    text-align: right;
    height: 32px;
    line-height: 32px;
    user-select: none;
    white-space: nowrap;
    overflow: hidden;
    &::after{
      content: "：";
    }
    &.required::before{
      content: "* ";
      color: var(--el-color-danger);
    }
  }
  .form-append{
    width: var(--icon-width);
    .append{
      margin-left: 10px;
      white-space: nowrap;
      height: 32px;
      line-height: 32px;
    }
  }
  .form-value{
    width: 100px;
    flex: 1;
    position: relative;
    line-height: 32px;
    font-size: var(--yq-font-size-base);
    .form-error,.form-desc{
      position: absolute;
      font-size: var(--yq-font-size-small);
      color: var(--el-color-danger);
      line-height: 16px;
    }
    .form-desc{
      color: var(--yq-font-color-info);
    }
  }
}
.show-block{
  width: 100% !important;
  align-items: flex-start;
}
</style>